

















import Vue from 'vue';
export default Vue.extend({
  name: 'QuoteTemplateTooltipIcon',

  props: {
    contentClass: {
      type: String,
      required: false
    },
    size: {
      type: Number,
      default: 22
    },
    note: {
      type: String,
      required: true
    }
  }
});
